import axios from 'axios';
import { BASE_URL } from '../path'; // Adjust path if needed

const api = axios.create({
  baseURL: BASE_URL + '/api/',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

// Attach token from storage if available
api.interceptors.request.use(config => {
  const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
}, error => {
  return Promise.reject(error);
});

export default api;
